import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const EmployeesPage = lazy(() =>
  import('./pages/EmployeesPage').then((module) => ({ default: module.EmployeesPage })),
);
const EmployeeDetailPage = lazy(() =>
  import('./pages/EmployeeDetailPage').then((module) => ({ default: module.EmployeeDetailPage })),
);
const IdBadgePrintPage = lazy(() =>
  import('./pages/IdBadgePrintPage').then((module) => ({ default: module.IdBadgePrintPage })),
);
const MyProfilePage = lazy(() =>
  import('./pages/MyProfilePage').then((module) => ({ default: module.MyProfilePage })),
);

export const employeesRoutes: RouteObject[] = [
  {
    path: 'trabajadores',
    children: [
      {
        // Its own gate: printing fotochecks is an RR.HH. task
        // (`print_id_badge`), not something every worker-list reader gets.
        path: 'fotochecks',
        element: createElement(ProtectedRoute, { view: 'idBadgePrint' }),
        children: [{ index: true, element: createElement(IdBadgePrintPage) }],
      },
      {
        element: createElement(ProtectedRoute, { view: 'employees' }),
        children: [
          { path: ':id', element: createElement(EmployeeDetailPage) },
          { index: true, element: createElement(EmployeesPage) },
        ],
      },
    ],
  },
  {
    // Own ficha: any worker reaches it with view_own_profile, no list permission.
    path: 'mi-ficha',
    element: createElement(ProtectedRoute, { view: 'myProfile' }),
    children: [{ index: true, element: createElement(MyProfilePage) }],
  },
];
